import React from "react";
import AddPackageComponent from "../../components/AddPackage";
import { useMutation } from "@tanstack/react-query";
import { useNotification } from "../../../../../context/NotificationProvider";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import { useAuth } from "../../../../../context/AuthProvider";
import { postPackage } from "../../../../../services/Handlers/MasterPackageService";

import { useHistory } from "react-router-dom";

export default function AddPackage() {
  const notification = useNotification();
  const localize = useLocalization();
  const history = useHistory();
  const { userDetail } = useAuth();

  const { isLoading: isLoadingSubmit, mutate: mutateSubmit } = useMutation(
    postPackage,
    {
      onSuccess: (res) => {
        if (res.status === 200 || res.status === 201) {
          notification.success(localize.getText("successAddData"));
          history.goBack();
        } else {
          notification.error(
            res?.data?.detail || localize.getText("unknownMessageError")
          );
        }
      },
      onError: (res) => {
        notification.error(localize.getText("unknownMessageError"));
      },
    }
  );

  const handleSubmit = (value) => {
    const data = {
      name: value.name,
      price: value.price,
      number_of_visit: value.numberOfVisit,
      items:
        (value.packageItems.every((item) => !!item.value) &&
          value.packageItems.map((item) => item.value)) ||
        [],
      busines_id: userDetail?.businessId,
      active: value.active !== false,
    };
    mutateSubmit(data);
  };

  return (
    <AddPackageComponent
      handleSubmit={handleSubmit}
      isLoadingSubmit={isLoadingSubmit}
    />
  );
}
